import { render, staticRenderFns } from "./QuickActions.vue?vue&type=template&id=c3cb14c8&scoped=true&lang=pug"
import script from "./QuickActions.vue?vue&type=script&lang=ts"
export * from "./QuickActions.vue?vue&type=script&lang=ts"
import style0 from "./QuickActions.vue?vue&type=style&index=0&id=c3cb14c8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3cb14c8",
  null
  
)

export default component.exports